import { Helpers } from '../../helpers';
import { IDrilloutMethod } from '../../interfaces/idrillout-method';
import { DrillGroup } from '../drill-group';
import { ProjectCompletionsParameter } from '../project-completions-parameter';
import { ScenarioWell } from '../scenario-well';

export class DrilloutMethodBase {
  DrilloutMethodId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  DrillGroups_DrilloutMethod?: Array<DrillGroup> | null;
  ScenarioWells_DrilloutMethod?: Array<ScenarioWell> | null;
  ProjectCompletionsParameters_DrillOutMethod?: Array<ProjectCompletionsParameter> | null;

  constructor(item?: IDrilloutMethod) {
    if (item) {

      this.DrilloutMethodId = item.DrilloutMethodId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.DrillGroups_DrilloutMethod = Helpers.createClassArray(DrillGroup, item.DrillGroups_DrilloutMethod);
      this.ScenarioWells_DrilloutMethod = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_DrilloutMethod);
      this.ProjectCompletionsParameters_DrillOutMethod = Helpers.createClassArray(ProjectCompletionsParameter, item.ProjectCompletionsParameters_DrillOutMethod);
    }
  }
}